import { LEGO_CONSTANTS } from 'constants/index';
import { shouldUseTypeBasedEntityApi } from 'utils/entityIdentifier';

const V2_ENTITIES_PATH = `/${LEGO_CONSTANTS.COUI_API_V2_ENTITIES_PATH}`;

/** LEGO typed-entity APIs expect `version: 2` when routing through the v2/entities surface. */
export const attachTypeBasedEntityApiHeaders = request => {
  if (!shouldUseTypeBasedEntityApi()) {
    return request;
  }
  const url = request?.url ?? '';
  if (!url.includes(V2_ENTITIES_PATH)) {
    return request;
  }
  request.headers = request.headers ?? {};
  request.headers.version = '2';
  return request;
};
